import * as chrono from 'chrono-node';
import { format, formatDistanceToNow } from 'date-fns';

export default function useDateTime() {
  /**
   * Format time in 24-hour format (HH:mm)
   */
  const getTime24HourFormat = (date: Date): string => format(date, 'HH:mm');

  /**
   * Format date in Dutch format (d MMM yy)
   */
  const getDateDutchFormat = (date: Date): string => format(date, 'd MMM yy');

  /**
   * Parse natural language date string to Date object
   */
  const getDateTimeFromNaturalLanguage = (naturalLanguage: string): Date =>
    chrono.nl.parseDate(naturalLanguage);

  /**
   * Format date as relative time (e.g., "5 minutes ago")
   */
  const formatRelativeTime = (date: Date): string =>
    formatDistanceToNow(date, { addSuffix: true });

  /**
   * Format date and time in a readable format (PPpp)
   * Example: "Apr 29, 2023, 9:30 AM"
   */
  const formatDateTime = (date: Date): string => format(date, 'PPpp');

  return {
    getTime24HourFormat,
    getDateDutchFormat,
    getDateTimeFromNaturalLanguage,
    formatRelativeTime,
    formatDateTime,
  };
}
